module.exports = __webpack_public_path__ + "static/media/notification-hover.4f921a8b.svg";